"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_BUTTON_FONT_TYPES = void 0;
var TEXT_BUTTON_FONT_TYPES = Object.freeze({
  body: 'body',
  bodyHeading: 'bodyHeading',
  bodySmall: 'bodySmall',
  bodySmallHeading: 'bodySmallHeading'
});
exports.TEXT_BUTTON_FONT_TYPES = TEXT_BUTTON_FONT_TYPES;